export const environment = {
  production: true,
  apiUrl: 'https://admin.bountyusa.com/bounty-api/public/api/',
  baseUrl: 'https://admin.bountyusa.com/bounty-api/public/',
  homeUrl: 'https://admin.bountyusa.com/home/',
};